import React from 'react';
import NumberInput from '../../TextFields/NumberInput.js';

/**
 * Component to render input fields for shares distribution among beneficiaries.
 * @param {object} props - The properties passed to the component.
 * @param {boolean} props.isContingent - Flag indicating if the beneficiary is contingent.
 * @param {array} props.contingentBeneficiaries - Array of contingent beneficiaries.
 * @param {array} props.primaryBeneficiaries - Array of primary beneficiaries.
 * @param {string} props.beneficiaryID - ID of the current beneficiary.
 * @param {boolean} props.sharesError - Flag indicating if there's an error with shares input.
 * @param {function} props.handleSharesChange - Function to handle shares change.
 * @returns {JSX.Element} - The BeneficiariesSharesInputs component JSX.
 */
const BeneficiariesSharesInputs = ({
  isContingent,
  contingentBeneficiaries,
  primaryBeneficiaries,
  beneficiaryID,
  sharesError,
  handleSharesChange
}) => /*#__PURE__*/React.createElement(React.Fragment, null, isContingent ? contingentBeneficiaries.map(currentBeneficiary => {
  if (currentBeneficiary.beneficiaryID === beneficiaryID) {
    return null;
  }
  return /*#__PURE__*/React.createElement("div", {
    key: currentBeneficiary.beneficiaryID,
    style: {
      flexDirection: 'row'
    }
  }, /*#__PURE__*/React.createElement(NumberInput, {
    label: currentBeneficiary.firstname,
    suffix: "%",
    value: currentBeneficiary.shares,
    onChange: e => handleSharesChange(currentBeneficiary.beneficiaryID, e.target.value),
    error: Boolean(sharesError),
    helperText: sharesError,
    fullWidth: true
  }));
}) : primaryBeneficiaries.map(currentBeneficiary => {
  if (currentBeneficiary.beneficiaryID === beneficiaryID) {
    return null;
  }
  return /*#__PURE__*/React.createElement("div", {
    key: currentBeneficiary.beneficiaryID,
    style: {
      flexDirection: 'row'
    }
  }, /*#__PURE__*/React.createElement(NumberInput, {
    label: currentBeneficiary.firstname,
    suffix: "%",
    value: currentBeneficiary.shares,
    onChange: e => handleSharesChange(currentBeneficiary.beneficiaryID, e.target.value),
    error: Boolean(sharesError),
    helperText: sharesError,
    fullWidth: true
  }));
}));
export default BeneficiariesSharesInputs;